import { useState } from 'react';
import { Button, FormInput } from "../../../components";
import { useDispatch, useSelector } from "react-redux";
import { selectAccessToken, selectPermissions } from "../../../slices/staffSlice";
import { fetchRequests } from '../../../Requests/getRequests';
import { authStaff, dateToHumanFormat, roundNum } from "../../../utils/constants";
import { useNavigate } from 'react-router-dom';
import { show } from '../../../slices/toastSlice';

function AutoDisburse({ loan }) {

    const accessToken = useSelector(selectAccessToken);
    const dispatch = useDispatch();
    const permissions = useSelector(selectPermissions);
    const canDisburse = permissions.includes('*:*') || permissions.includes('loans:disburse');
    const navigate = useNavigate();

    const [repaymentDate, setRepaymentDate] = useState("");
    const [processing, setProcessing] = useState(false);
    const [error, setError] = useState(false);

    const principalAmount = loan?.amount;
    const processingFee = loan?.accountInfo?.processingFee;
    const insuranceFee = loan?.accountInfo?.insuranceFee;
    // const networkProcessing = roundNum(((0.5 / 100) * loan?.amount), 2); 
    const amountToDisburse = roundNum((loan?.accountInfo?.amountGiven), 2);

    const handleDisbursement = async(e) => {
        e.preventDefault();
        setProcessing(true);

        let url = `/payments/staff/initiate-payment`;
        let headers = authStaff(accessToken);

        let data = {
            _id : loan?._id,
            type : loan?.type.toLowerCase(),
            state : loan?.state,
            repaymentDate
        }

        let res = await fetchRequests(url, "POST", headers, {}, data);
        setProcessing(false);
        
        if(res?.code === 401){
            // clear local storage and redirect to login
            sessionStorage.clear();
			navigate("/login");
            dispatch(show({
                type : "error",
                state : true,
                message : "Your session has expired. Please login to continue."
            }))
            return;
        }

        if(res?.err){
            setError(`Funds could not be disbursed at this moment, please try again in a few minutes`);
            return;
        } 

        dispatch(show({
            type : "success",
            state : true,
            message : `Funds disbursed successfully.`
        }))
        setTimeout(() => {
            navigate("/active-loans")
        },1500)
    }

    return (
        <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm overflow-hidden mt-4">
            <div className="px-5 py-3.5 border-b border-gray-100 dark:border-gray-700">
                <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-200">Auto Disbursement</h4>
            </div>
            <div className="px-5 py-5">
                <form className="space-y-5">
                    <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5'>
                                            <div>
                                                <label htmlFor="customerName" className='form-label'>Name of Customer</label>
                                                <FormInput 
                                                    type="text"
                                                    name="customerName"
                                                    id="customerName"
                                                    required
                                                    disabled={true}
                                                    value={`${loan?.client?.otherNames} ${loan?.client?.surname}`}
                                                />
                                            </div>

                                            <div>
                                                <label htmlFor="mobileNumber" className='form-label'>Mobile Number</label>
                                                <FormInput 
                                                    type="number"
                                                    name="mobileNumber"
                                                    id="mobileNumber"
                                                    required
                                                    disabled={true}
                                                    value={loan?.phone}
                                                />
                                            </div>

                                            <div>
                                                <label htmlFor="mobileMoneyWallet" className='form-label'>Mobile Money Network</label>
                                                <select name="file-upload" id="file-upload" className="form-input disabled:opacity-75 disabled:bg-gray-200" disabled>
                                                    <option defaultValue={"MTN"}>MTN</option>
                                                    <option value="MTN">MTN</option>
                                                    <option value="Vodafone">Vodafone</option>
                                                    <option value="Airtel - Tigo">Airtel - Tigo</option>
                                                </select>
                                            </div>

                                            <div>
                                                <label htmlFor="principalAmount" className='form-label'>Approved Amount</label>
                                                <FormInput 
                                                    type="number"
                                                    name="principalAmount"
                                                    id="principalAmount"
                                                    required
                                                    disabled={true}
                                                    value={principalAmount}
                                                />
                                            </div>

                                            <div>
                                                <label htmlFor="processingFee" className='form-label'>Processing Fee</label>
                                                <FormInput 
                                                    type="number"
                                                    name="processingFee"
                                                    id="processingFee"
                                                    required
                                                    disabled={true}
                                                    value={processingFee}
                                                />
                                            </div>

                                            <div>
                                                <label htmlFor="insuranceFee" className='form-label'>Insurance Fee</label>
                                                <FormInput 
                                                    type="number"
                                                    name="insuranceFee"
                                                    id="insuranceFee"
                                                    required
                                                    disabled={true}
                                                    value={insuranceFee}
                                                />
                                            </div>

                                            {/* <div>
                                                <label htmlFor="networkFee" className='form-label'>Network Processing Fee</label>
                                                <FormInput 
                                                    type="number"
                                                    name="networkFee"
                                                    id="networkFee"
                                                    required
                                                    disabled={true}
                                                    value={networkProcessing}
                                                />
                                            </div> */}

                                            <div>
                                                <label htmlFor="amountToDisburse" className='form-label'>Amount to Disburse</label>
                                                <FormInput 
                                                    type="number"
                                                    name="amountToDisburse"
                                                    id="amountToDisburse"
                                                    required
                                                    disabled={true}
                                                    value={amountToDisburse}
                                                />
                                            </div>

                                            <div>
                                                <label htmlFor="repaymentDate" className='form-label'>Repayment Start Date</label>
                                                <input 
                                                    type="date"
                                                    name={"repaymentDate"}
                                                    id={"repaymentDate"}
                                                    className="form-input disabled:opacity-75 disabled:bg-gray-200 placeholder:text-gray-700 disabled:cursor-not-allowed"
                                                    required={false}
                                                    value={repaymentDate}
                                                    onChange={e => setRepaymentDate(e.target.value)}
                                                    min={new Date().toISOString().split('T')[0]}
                                                />
                                            </div>
                    </div>

                    <div className='flex gap-3 p-4 rounded-lg border border-amber-200 dark:border-amber-500/20 bg-amber-50 dark:bg-amber-500/5 text-sm text-amber-800 dark:text-amber-300 leading-relaxed'>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5 shrink-0 mt-0.5 text-amber-500">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                        <p>
                            If the loan is disbursed today without "Repayment Start Date" being altered, the repayment start date would be <strong>{dateToHumanFormat(loan?.startDate)}</strong> and would end <strong>{dateToHumanFormat(loan?.endDate)}</strong>. If the client has a "Standing Order" and this was indicated in the loan application, input the date the standing order would be activated as the "Repayment Start Date". The additional five (5) days would be added to the repayment end date.
                        </p>
                    </div>

                    <div className={`pt-1 ${!canDisburse && 'hidden'}`}>
                        <Button
                            btnText={"Disburse"}
                            btnType="submit"
                            btnClasses={"form-button w-auto"}
                            disabled={processing}
                            processing={processing}
                            btnFunction={handleDisbursement}
                        />
                    </div>
                </form>

                {error &&
                    <div className='mt-4 flex gap-3 p-4 rounded-lg border border-red-200 dark:border-red-500/20 bg-red-50 dark:bg-red-500/5 text-sm text-red-800 dark:text-red-300'>
                        {error}
                    </div>
                }
            </div>
        </div>
    )
}

export default AutoDisburse